define('common/ko/fn/unwrapped',['knockout'], function(ko) {

    /**
     * Use when your observable contains an observable that you want unwrapped
     *
     * Useful for managing the dependencies of computeds
     */
    ko.subscribable.fn.unwrapped = function () {

        var subject = this;

        return ko.pureComputed({
            read: function () {
                return ko.unwrap(subject());
            },
            write: subject
        });

    };

});

